module.exports = __webpack_public_path__ + "static/media/28-4.9b8c3a18.mp3";